import Fuse, { IFuseOptions } from "fuse.js";
import { LinkSearchRules } from "./@types/LLMSummary";

export const TOKEN_REGEX = /[^\s/-]+/g;

export const MAX_PROXIMITY = 4;
export const fuseConf: IFuseOptions<string> = {
  threshold: 0.3,
  minMatchCharLength: 4,
  isCaseSensitive: false
};

export const LINK_SEARCH_LIST_RL_DYNAMIC: LinkSearchRules[] = [
  {
    keyword: "dynamic",
    url: "rl_dynamic_analysis/signatures",
    adjacentMatch: new Fuse(
      ["cloud", "analysis", "execution", "sandbox"],
      fuseConf
    )
  },
  {
    keyword: "dynamic",
    url: "rl_dynamic_analysis/sigma",
    adjacentMatch: new Fuse(["sigma"], fuseConf)
  },
  {
    keyword: "dynamic",
    url: "rl_dynamic_analysis/network_analysis",
    adjacentMatch: new Fuse(["network"], fuseConf)
  },
  {
    keyword: "dropped",
    url: "rl_dynamic_analysis/dropped_files",
    adjacentMatch: new Fuse(["files"], fuseConf)
  },
  {
    keyword: "dynamic",
    url: "rl_dynamic_analysis/dropped_files",
    adjacentMatch: new Fuse(["drops"], fuseConf)
  }
];

export const LINK_SEARCH_LIST_EXTRACTED_FILES: LinkSearchRules[] = [
  {
    keyword: "file",
    url: "extracted-files",
    adjacentMatch: new Fuse(["extracted"], fuseConf)
  }
];

export const LINK_SEARCH_LIST: LinkSearchRules[] = [
  ...LINK_SEARCH_LIST_RL_DYNAMIC,
  ...LINK_SEARCH_LIST_EXTRACTED_FILES
];
export const TYPE_TO_DISPLAY: { [key: string]: string } = {
  hash_sha1: "SHA1",
  hash_md5: "MD5",
  hash_sha256: "SHA256",
  hash_sha512: "SHA512",
  tlsh: "TLSH",
  ssdeep: "SSDEEP",
  uri_ipv4: "IPv4",
  uri_ipv6: "IPv6",
  uri_domain: "Domain",
  uri_url: "URL",
  uri_mail: "E-mail",
  hash_rha0: "RHA0",
  hash_rha1: "RHA1",
  hash_imphash: "ImpHash",
  hash_tlsh: "TLSH",
  hash_ssdeep: "SSDEEP",
  file_name: "File name",
  file_type: "File type",
  threat_name: "Threat name",
  yara_identifier: "Yara identifier",
  email_subject: "E-mail subject",
  email_to: "E-mail to",
  email_from: "E-mail from"
};
